import request from '@/utils/request'

export function homeInfo() {
  return request({
    url: '/home/homeInfo',
    method: 'get',
  })
}

export function merchantPrinter() {
  return request({
    url: '/merchantPrinter/getMerchantPrinterList',
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/home.js